export default __webpack_public_path__ + "static/media/ic_purchase.d2cb434f.svg";